import { addFilter } from '@wordpress/hooks'
import CreatePyment from './CreatePayment';

addFilter( 'wptravel_booking_button_payment_auth', 'wp-travel', ( content, val ) => {
    return <CreatePyment />;
})